/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Status_Uploading_SnapshotInputs */

const en_team_sync_status_uploading_snapshot = /** @type {(inputs: Team_Sync_Status_Uploading_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading snapshot to storage...`)
};

const fr_team_sync_status_uploading_snapshot = /** @type {(inputs: Team_Sync_Status_Uploading_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléversement du snapshot vers le stockage...`)
};

const de_team_sync_status_uploading_snapshot = /** @type {(inputs: Team_Sync_Status_Uploading_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snapshot wird in den Speicher hochgeladen...`)
};

const it_team_sync_status_uploading_snapshot = /** @type {(inputs: Team_Sync_Status_Uploading_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento dello snapshot nell'archivio...`)
};

const ru_team_sync_status_uploading_snapshot = /** @type {(inputs: Team_Sync_Status_Uploading_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка снимка в хранилище...`)
};

const es_team_sync_status_uploading_snapshot = /** @type {(inputs: Team_Sync_Status_Uploading_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando instantánea al almacenamiento...`)
};

const zh_cn2_team_sync_status_uploading_snapshot = /** @type {(inputs: Team_Sync_Status_Uploading_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在将快照上传到存储设备...`)
};

const ja_team_sync_status_uploading_snapshot = /** @type {(inputs: Team_Sync_Status_Uploading_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スナップショットをストレージにアップロードしています...`)
};

const hi_team_sync_status_uploading_snapshot = /** @type {(inputs: Team_Sync_Status_Uploading_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्नैपशॉट को स्टोरेज में अपलोड किया जा रहा है...`)
};

const pt_pt2_team_sync_status_uploading_snapshot = /** @type {(inputs: Team_Sync_Status_Uploading_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando instantâneo para o armazenamento...`)
};

/**
* | output |
* | --- |
* | "Uploading snapshot to storage..." |
*
* @param {Team_Sync_Status_Uploading_SnapshotInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_status_uploading_snapshot = /** @type {((inputs?: Team_Sync_Status_Uploading_SnapshotInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Status_Uploading_SnapshotInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_status_uploading_snapshot(inputs)
	if (locale === "de") return de_team_sync_status_uploading_snapshot(inputs)
	if (locale === "it") return it_team_sync_status_uploading_snapshot(inputs)
	if (locale === "ru") return ru_team_sync_status_uploading_snapshot(inputs)
	if (locale === "es") return es_team_sync_status_uploading_snapshot(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_status_uploading_snapshot(inputs)
	if (locale === "ja") return ja_team_sync_status_uploading_snapshot(inputs)
	if (locale === "hi") return hi_team_sync_status_uploading_snapshot(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_status_uploading_snapshot(inputs)
	return en_team_sync_status_uploading_snapshot(inputs)
});